function requireEnv(key: string): string {
  const value = import.meta.env[key];
  if (!value) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value;
}

export const config = {
  apiUrl: requireEnv('VITE_API_URL'),
  aws: {
    region: requireEnv('VITE_AWS_REGION'),
    cognito: {
      userPoolId: requireEnv('VITE_COGNITO_USER_POOL_ID'),
      userPoolClientId: requireEnv('VITE_COGNITO_USER_POOL_CLIENT_ID'),
      identityPoolId: requireEnv('VITE_COGNITO_IDENTITY_POOL_ID'),
    },
  },
};
